import { Auth } from '../../../shared/auth/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { ImUser } from '../../../shared/services/im-models/im-user';
import { getCurrentUser, getCurrentUserLoadedStatus } from '../../../store/selectors/current-user-selectors';
import { LoadCurrentUser } from '../../../store/actions/current-user-actions';

@Injectable()
export class NonEntityUserGuard implements CanActivate {
  constructor (
    private store: Store<any>,
    private auth: Auth,
    private router: Router,
    private ImUser: ImUser) {}

  canActivate (): Observable<UrlTree|boolean> {
    return this.getFromStoreOrAPI().pipe(
      switchMap((user) => {
        const isEntityUser = this.ImUser.isEntityUser(user);
        if (isEntityUser) return of(this.router.createUrlTree(['not-found']));
        return of(true);
      }),
      catchError(() => of(false)),
    );
  };

  getFromStoreOrAPI (): Observable<any> {
    return this.store.select(getCurrentUserLoadedStatus).pipe(
      tap(async loaded => {
        if (!loaded) {
          const email = await this.auth.getCurrentUserEmail();
          this.store.dispatch(new LoadCurrentUser({ email }));
        }
      }),
      filter(loaded => loaded),
      switchMap(() => this.store.select(getCurrentUser)),
      take(1),
    );
  }
}
